var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOkButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#669;stroke-miterlimit:10;stroke-width:6px;}.c{fill:#669;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 91.5,
    cy: 91.5,
    r: 88.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M157.57,58.25c0,2.5-.77,5.02-2.37,7.18l-59.52,80.53c-3.43,4.63-9.54,6.12-14.59,3.89-.02,0-.03,0-.04,0-1.67-.58-3.23-1.54-4.56-2.87L28.98,99.47c-4.73-4.73-4.73-12.4,0-17.13,2.37-2.37,5.46-3.54,8.56-3.54s6.19,1.17,8.56,3.54l38.23,38.23,51.38-69.53c3.98-5.37,11.56-6.52,16.93-2.54,3.21,2.37,4.92,6.04,4.92,9.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkButton);
export default __webpack_public_path__ + "static/media/ok-button.b2d6c8ff71a2093a8f797a1cc5923e3c.svg";
export { ForwardRef as ReactComponent };